export default {
  fundFrecast: {
    //资金预报表管理
    column: {
      tenantCode: '租户编码',
      companyCode: '公司编码',
      departmentCode: '部门编码',
      company: '公司',
      department: '事业部',
      departmentName: '部门',
      gmtCreate: '记录创建时间',
      gmtModified: '记录更新时间',
      lastModifiedBy: '记录最后更新人',
      isDeleted: '是否删除(1删除,0未删除)',
      sortNo: '序号',
      version: '版本',
      //originFlag: '数据来源,[表名的驼峰写法]-另外三张表',
      originFlag: '数据来源',
      originId: '来源id',
      planCycle: '计划周期',
      planStartDate: '计划开始日期',
      planEndDate: '计划结束日期',
      forecastCompanyCode: '预报表公司',
      forecastDepartmentCode: '预报表部门',
      forecastYear: '年度',
      forecastMonth: '月份',
      forecastDate: '日期',
      startForecastDate: '开始日期',
      endForecastDate: '结束日期',
      financeBank: '融资银行',
      financeVariety: '融资品种',
      receiveAmount: '收款',
      payAmount: '付款',
      planRestAmount: '计划余额',
      bankRestAmount: '银行余额',
      creditNo: '信用证号',
      creditForm: '信用证性质',
      mark: '备注',
      principal: '本金',
      lockRemitPrice: '锁汇价格',
      lockRemitAmount: '锁汇金额',
      currencyType: '币别',
      foreignCurrencyType: '外币币别',
      year: '年',
      month: '月',
    },
    placeholder: {
      tenantCode: '请输入租户编码',
      companyCode: '请输入公司编码',
      departmentCode: '请输入部门编码',
      company: '请选择公司',
      companyName: '请输入公司名',
      departmentName: '请输入部门名',
      gmtCreate: '请选择记录创建时间',
      gmtModified: '请选择记录更新时间',
      lastModifiedBy: '请输入记录最后更新人',
      isDeleted: '请输入是否删除(1删除,0未删除)',
      sortNo: '请输入序号',
      version: '请输入版本',
      originFlag: '请输入数据来源,[表名的驼峰写法]-另外三张表',
      originId: '请输入来源id',
      planCycle: '请输入计划周期',
      forecastCompanyCode: '请输入预报表公司',
      forecastDepartmentCode: '请输入预报表部门',
      forecastYear: '请输入年度',
      forecastMonth: '请输入月份',
      forecastDate: '请选择日期',
      financeBank: '请输入融资银行',
      financeVariety: '请输入融资品种',
      receiveAmount: '请输入收款',
      payAmount: '请输入付款',
      planRestAmount: '请输入计划余额',
      bankRestAmount: '请输入银行余额',
      currencyType: '请输入币别',
      creditNo: '请输入信用证号',
      creditForm: '请输入信用证性质',
      mark: '请输入备注',
      principal: '请输入本金',
      lockRemitPrice: '请输入锁汇价格',
      lockRemitAmount: '请输入锁汇金额',
      foreignCurrencyType: '请选择外币币别',
      lastMonthRemaining: '上期可用余额',
      totoalReceiveAmount: '本期新增',
      totoalPayAmount: '本期使用',
      remaining: '本期可用余额',
    },
    button: {
      export: '导出',
      total: '合计',
      maintainBankBalance: '维护银行余额',
      cancel: '取 消',
      confirm: '确 认',
      saveSussess: '保存成功',
    },
    message: {
      showTotalFailed: '暂无合计数据',
    },
    table: {
      bankBalanceInfo: '历史维护银行余额记录',
    },
  },
};
